<mat-dialog-content>
    <div *ngIf="isLoading" class="overlay"></div>
    <div *ngIf="isLoading" class="loader"></div>
    <mat-tab-group class="mat-tab-group">
        <mat-tab label="General Data">
            <mat-card>
                <mat-card-content>
                    <h1 class="menu-sub-item-header mat-icon-container">Stock Count</h1>
                    <p>
                    <form [formGroup]="productForm">

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Title: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="title" matInput formControlName="title" readonly="readonly"  />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Store: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="store" matInput formControlName="store" readonly="readonly"  />
                                </div>
                            </div>
                        </div>

                          <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Items per Unit: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input type="number" name="itemsPerUnit" matInput formControlName="itemsPerUnit" readonly="readonly" />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Stock Count: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input type="number" name="stockCount" matInput formControlName="stockCount" required />
                                </div>
                            </div>
                        </div>


                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    &nbsp;
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    &nbsp;
                                </div>
                            </div>
                          </div>

                    </form>
                </mat-card-content>
                <mat-card-actions class="mat-form-button-container">
                    <div class="flex flex-align-items-center">
                        <div class="mr-auto">
                        </div>
                        <button style="float: none;" type="button" mat-raised-button (click)="dialogRef.close()"
                            color="warn">Cancel</button>
                        <button style="float: none;" type="button" mat-raised-button (click)="updateProduct()" color="warn"
                            [disabled]="!productForm.valid">Save</button>
                    </div>
                    <br/>
                </mat-card-actions>
            </mat-card>
        </mat-tab>

    </mat-tab-group>
</mat-dialog-content>
